import ArrowItem from "../ArrowItem/ArrowItem"

export default ArrowItem
